import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

import careersHeroImage from "../../../assets/images/careers/careers_heroimage.webp";

const HeroTitleContainer = styled(motion.section).attrs({
  className: "u-w100 u-col-center",
})`
  position: relative;
  height: 100dvh;
  
  background-image: url(${careersHeroImage});
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  
  overflow: hidden;
  
  /* スクロールスナップの設定 */
  scroll-snap-align: start;
`;

const HeroTagline = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  text-align: center;
  padding: 0 20px;
  
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const MainTitle = styled(motion.h1)`
  font-family: "din-2014-rounded-variable", sans-serif;
  font-variation-settings: "wght" 200;
  font-style: normal;
  
  font-size: clamp(4rem, 3.273rem + 3.64vw, 8rem);
  line-height: 100%;
  letter-spacing: 0.05em;
  
  color: #000;
`;

const SubTitle = styled(motion.p)`
  font-family: "A+mfCv-AXISラウンド 50 L StdN", "M PLUS 1p", sans-serif;
  font-weight: normal;
  
  font-size: clamp(1rem, 0.8rem + 1vw, 1.5rem);
  line-height: 150%;
  letter-spacing: 0.3em;
  
  color: #000;
`;

const CareersHeroTitle: React.FC = () => {
  return (
    <HeroTitleContainer
      initial={{ opacity: 0, scale: 1.1 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 1.5 }}
    >
      <HeroTagline>
        <MainTitle
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.5 }}
        >
          Careers
        </MainTitle>
        <SubTitle
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.8 }}
        >
          SOREMOで働く
        </SubTitle>
      </HeroTagline>
    </HeroTitleContainer>
  );
};

export default CareersHeroTitle;

